import React, { useState, useEffect } from "react";
import axios from "axios";
import "./AdminGallery.css";
import { Fade } from "react-awesome-reveal";
import AdminNavbar from "./AdminNavbar";
import { FaTimes } from "react-icons/fa";
import ImageWithLoader from "./ImageWithLoader";



function AdminGallery() {
    const [categories, setCategories] = useState([]);
    const [subcategories, setSubcategories] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState("");
    const [selectedSubcategory, setSelectedSubcategory] = useState("");
    const [images, setImages] = useState([]);
    const [welcomeVisible, setWelcomeVisible] = useState(true);
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [editData, setEditData] = useState(null);

    // Fetch categories from backend on load
    useEffect(() => {
        axios.get("https://himchatterjee.in/backend/getCategories.php")
            .then((res) => setCategories(res.data))
            .catch((err) => console.log(err));
    }, []);

    // Fetch subcategories whenever a category is selected
    useEffect(() => {
        if (selectedCategory) {
            axios.post(
                "https://himchatterjee.in/backend/getSubcategories.php",
                new URLSearchParams({ id: selectedCategory }),
                { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
            )
                .then(res => {
                    const data = Array.isArray(res.data) ? res.data : [];
                    setSubcategories(data);
                    if (data.length > 0) setSelectedSubcategory(data[0].id);
                })
                .catch(err => console.log(err));
        } else {
            setSubcategories([]);
            setSelectedSubcategory("");
        }
    }, [selectedCategory]);

    // Fetch images whenever a subcategory is selected
    // AdminGallery.js me images fetch karte waqt:
    useEffect(() => {
        if (selectedCategory && selectedSubcategory) {
            axios.get(`https://himchatterjee.in/backend/getAdminImages.php?cat=${selectedCategory}&subcat=${selectedSubcategory}`)
                .then(res => setImages(Array.isArray(res.data) ? res.data : []))
                .catch(err => setImages([]));
        } else {
            setImages([]);
        }
    }, [selectedCategory, selectedSubcategory]);

    // ...existing code...

    const handleDelete = (id) => {
        if (window.confirm("Are you sure you want to delete this image?")) {
            axios.post(
                "https://himchatterjee.in/backend/deleteImage.php",
                JSON.stringify({ id }),
                { headers: { "Content-Type": "application/json" } }
            )
                .then(res => {
                    if (res.data.success) {
                        setImages(images.filter(img => img.id !== id));
                    } else {
                        alert("Delete failed: " + (res.data.error || "Unknown error"));
                    }
                })
                .catch(() => alert("Delete failed!"));
        }
    };

    // Edit button handler
    const handleEdit = (img) => {
        setEditData({ ...img }); // clone so we can edit
        setEditModalOpen(true);
    };

    // Update button handler
    const handleUpdate = () => {
        axios.post(
            "https://himchatterjee.in/backend/updateImage.php",
            JSON.stringify(editData),
            { headers: { "Content-Type": "application/json" } }
        )
            .then(res => {
                if (res.data.success) {
                    setImages(images.map(img => img.id === editData.id ? { ...img, ...editData } : img));
                    setEditModalOpen(false);
                } else {
                    alert("Update failed: " + (res.data.error || "Unknown error"));
                }
            })
            .catch(() => alert("Update failed!"));
    };

    return (

        <div className="admin-gallery-container">
            <AdminNavbar />
            {/* Welcome Animation */}
            {welcomeVisible && (
                <Fade duration={2000} triggerOnce>
                    <div className="welcome-message">
                        <h1>Welcome to Gallery Selection</h1>
                        <p>Select a category to start exploring the artworks!</p>
                        <button onClick={() => setWelcomeVisible(false)}>Start</button>
                    </div>
                </Fade>
            )}

            {!welcomeVisible && (
                <div className="dropdown-section">
                    {/* Category Dropdown */}
                    <div className="dropdown-wrapper">
                        <label>Select a Category</label>
                        <select value={selectedCategory} onChange={(e) => setSelectedCategory(e.target.value)}>
                            <option value="">-- Select a Category --</option>
                            {Array.isArray(categories) && categories.map(cat => (
                                <option key={cat.id} value={cat.id}>{cat.name}</option>
                            ))}
                        </select>
                    </div>

                    {/* Subcategory Dropdown */}
                    <div className="dropdown-wrapper">
                        <label>Select Subcategory</label>
                        <select
                            value={selectedSubcategory}
                            onChange={(e) => setSelectedSubcategory(e.target.value)}
                            disabled={!selectedCategory}
                        >
                            {selectedCategory && Array.isArray(subcategories) ? (
                                subcategories.map(sub => (
                                    <option key={sub.id} value={sub.id}>{sub.name}</option>
                                ))
                            ) : (
                                <option>Select a category first</option>
                            )}
                        </select>
                    </div>
                </div>
            )}

            {/* Gallery Display */}
            {selectedSubcategory && (
                <div className="gallery-display">
                    <h2>Images for selected subcategory</h2>
                    {images.length === 0 ? (
                        <p>No images found.</p>
                    ) : (
                        <table className="admin-gallery-table">
                            <thead>
                                <tr>
                                    {/* <th>Image Id</th> */}
                                    <th>Image</th>
                                    <th>Title</th>
                                    <th>Description</th>
                                    <th>OPTIONS</th>
                                </tr>
                            </thead>
                            <tbody>
                                {images.map(img => (
                                    <tr key={img.id}>
                                        {/* <td>{img.id}</td> */}
                                        <td>
                                            {img.img_path ? (
                                                <ImageWithLoader
                                                    src={`https://himchatterjee.in/backend/${img.img_path}`}
                                                    alt={img.title || "Image"}
                                                    width={80}
                                                    height={80}
                                                />
                                            ) : "No Image"}
                                        </td>

                                        <td>{img.title || ""}</td>
                                        <td>{img.description || ""}</td>
                                        <td>
                                            <button className="edit-btn" onClick={() => handleEdit(img)}>
                                                <span role="img" aria-label="edit">✏️</span> Edit
                                            </button>
                                            <button className="delete-btn" onClick={() => handleDelete(img.id)}>
                                                <span role="img" aria-label="delete">🗑️</span> Delete
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>
            )}
            {/* Edit Modal */}
            {editModalOpen && editData && (
                <div className="modal-overlay">
                    <div className="modal-content pro-modal">
                        <button
                            className="modal-close-btn"
                            onClick={() => setEditModalOpen(false)}
                            aria-label="Close"
                        >
                            <FaTimes size={18} />
                        </button>
                        <h2>Edit Image Details</h2>
                        <div className="modal-img-preview">
                            {editData.img_path && (
                                <div className="img-preview-box">
                                    <img
                                        src={`https://himchatterjee.in/backend/${editData.img_path}`}
                                        alt="Preview"
                                    />
                                </div>
                            )}
                        </div>
                        <label>Title:</label>
                        <input
                            type="text"
                            value={editData.title || ""}
                            onChange={e => setEditData({ ...editData, title: e.target.value })}
                        />
                        <label>Description:</label>
                        <textarea
                            value={editData.description || ""}
                            onChange={e => setEditData({ ...editData, description: e.target.value })}
                        />
                        <div className="modal-actions">
                            <button className="primary-btn" onClick={handleUpdate}>💾 Update</button>
                            <button className="secondary-btn" onClick={() => setEditModalOpen(false)}>Cancel</button>
                        </div>

                    </div>
                </div>
            )}
        </div>
    );
}

export default AdminGallery;